import { UserCirclePlus } from '@phosphor-icons/react';

export default UserCirclePlus;
